import moment from 'moment';
import { create } from 'zustand';
import { getUniqueId } from '../common/common';
import { IFilter } from '../model/CommonModel';
import { GetAuditByWayBillService, GetHistoryDetailByWayBillService, GetPieceLevelTrackingDetailByWayBillService, GetPieceLevelTrackingDetailService, GetRealtimeTemperature, GetTemperatureByWayBillService, GetTemperatureHistoryByImeiService, GetTrackingHistoryByWayBillService, GetTrackingHistoryService, SearchTrackingFilterService } from '../services/tracking-history-service';
import { FOUR_HUNDRED, PADDING_LENGTH, appendZero } from '../utils/app-common';
import { AuditResponse, IAuditChild, ITrackingHistoryInitialValue, ITrackingHistoryState } from './../model/TrackingHistoryModal';
import { responseData } from './common';
import { TrackWayBillService } from '../services/booking-service';
import { getNotificationStyle } from '../common/notification';

const initialValue: ITrackingHistoryInitialValue = {
    trackingHistoryList: [],
    trackingHistory: [],
    auditList: [],
    temperatureHistoryList: [],
    pieceLevelTrackingDetail: [],
    temperatureHistory: [],
    pieceTrackingDetail: [],
    trackingHistoryDetail: {},
    rowDetail: {
        id: 0,
        billTypeId: 0,
        waybillNo: '',
        bookingDate: 0,
        deliveryDate: 0,
        assignVehicle: 0,
    },
    waybillTracking: {},
};

const convert = (list: any[]) => {
    return list?.map((item) => ({
        ...item,
        pickupdate: item?.pickupdate ? +appendZero(item?.pickupdate, PADDING_LENGTH) : undefined,
        last_event_date: item?.last_event_date ? +appendZero(item?.last_event_date, PADDING_LENGTH) : undefined,
        delivery_date: item?.delivery_date ? +appendZero(item?.delivery_date, PADDING_LENGTH) : undefined,
    }));
}
const TrackingHistoryStore = create<ITrackingHistoryState>(((set) => ({
    ...initialValue,
    GetTrackingHistoryAction: async (filteredData: IFilter) => {
        set({ trackingHistoryList: [] });
        const response = await GetTrackingHistoryService(filteredData);
        set({ trackingHistoryList: convert(responseData(response?.data)) });
    },
    GetTrackingHistoryByWayBillAction: async (wayBill: string) => {
        set({ trackingHistory: [] })
        const response = await GetTrackingHistoryByWayBillService(wayBill);
        set({ trackingHistory: responseData(response?.data) })
    },
    GetHistoryDetailByWayBillAction: async (wayBill: string) => {
        set({ trackingHistoryDetail: {} });
        const response = await GetHistoryDetailByWayBillService(wayBill);
        set({ trackingHistoryDetail: responseData(response?.data) })
    },
    GetPieceLevelTrackingDetailByWayBillAction: async (wayBill: string) => {
        set({ pieceLevelTrackingDetail: [] });
        const response = await GetPieceLevelTrackingDetailByWayBillService(wayBill);
        set({ pieceLevelTrackingDetail: responseData(response?.data) })
    },
    GetPieceLevelTrackingDetailAction: async (pieceNumber: string) => {
        set({ pieceTrackingDetail: [] });
        const response = await GetPieceLevelTrackingDetailService(pieceNumber);
        set({ pieceTrackingDetail: responseData(response?.data) })
    },
    SearchFilterAction: async (filteredData: Partial<IFilter>) => {
        set({ trackingHistoryList: [] })
        const response = await SearchTrackingFilterService({ ...filteredData, startIndex: 1, count: 2000 });
        set({ trackingHistoryList: convert(responseData(response?.data)) })
    },
    GetAuditByWayBillAction: async (wayBill: string) => {
        set({ auditList: [] });
        const response = await GetAuditByWayBillService(wayBill);
        const auditList = responseData(response?.data)?.map((audit: IAuditChild[]) => ({
            id: getUniqueId(),
            name: 'Record',
            updatedDate: audit?.at(0)?.updatedDate,
            sortDate: moment(audit?.at(0)?.updatedDate),
            updatedBy: audit?.at(0)?.updatedBy,
            children: audit?.map(({ fieldName, oldValue, newValue }: IAuditChild) => ({
                fieldName,
                oldValue: oldValue ?? 0,
                newValue: newValue ?? 0,
                id: getUniqueId()
            }))
        })).sort((a: AuditResponse, b: AuditResponse) => a?.sortDate.diff(b?.sortDate)
        ) as AuditResponse[];
        set({
            auditList
        })
    },
    GetTemperatureByWayBillAction: async (wayBill: string) => {
        const response = await GetTemperatureByWayBillService(wayBill);
        set({ temperatureHistory: responseData(response?.data) })
    }
    , GetTemperatureHistoryByImei: async (imei: string) => {
        const response = await GetTemperatureHistoryByImeiService(imei);
        set({ temperatureHistory: responseData(response?.data) })
    },
    GetTemperatureByAction: async () => {
        const response = await GetRealtimeTemperature();
        set({ temperatureHistory: responseData(response?.data) })
    },
    TrackWaybillAction: async (waybillNo: string) => {
        const response = await TrackWayBillService(waybillNo);
        set({ waybillTracking: responseData(response?.data) || {} });
        if (response?.status === FOUR_HUNDRED) {
            getNotificationStyle(response);
        }
    },
    ClearTrackingStore: () => set({
        trackingHistory: []
    }),
    ClearTemperatureTrackingStore: () => set({
        trackingHistory: []
    }),
    clearTrackingHistoryStore: () => {
        set({ ...initialValue });
    }
})))

export const useTrackingHistoryStore = (TrackingHistoryStore)